import { Component, OnInit, ViewChild } from '@angular/core';
import { Input } from "@angular/core";
import { OrganizationInfo } from "src/app/model/organization";
import { CommonService } from "src/app/services/common.service";
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

declare function configDatePicker(id,endDate);
declare function readDatePicker(id);
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.css']
})
export class ApplicationComponent implements OnInit {

public time: any;
public states: any;
 private _organizationInfo: OrganizationInfo;

  @ViewChild('registrationForm')
  public registrationForm: NgForm;
  
 @Input()
  public get organizationInfo(): OrganizationInfo { return this._organizationInfo; }
  public set organizationInfo(v: OrganizationInfo) { this._organizationInfo = v; }
  constructor(private _commonService: CommonService) { }


  ngOnInit() {
    this.getTime();
    this.getStates();
     configDatePicker('#divReportedDate', new Date());
   
      $('#divReportedDate').datepicker('update', new Date().toLocaleDateString());

      $('#divReportedDate').datepicker().on('changeDate', function (e) {
      
    });
    setTimeout(() => {
     // this.InitilaizeComponent();
    }, 300);
    
  }

public onTimeChange (event, i) {

if ((this.organizationInfo.OperationHours[i].StartTime != '') && 
(this.organizationInfo.OperationHours[i].EndTime != '')) {
  this.organizationInfo.OperationHours[i].IsSelected = true;
} else {
   this.organizationInfo.OperationHours[i].IsSelected = false;
}
}
 public getTime () {
     this.time = this._commonService.getTime();
  }

public getStates () {
     this.states = this._commonService.getStates();
  }
public getFoundedOnDate () {
   // this.organizationInfo.FoundedOn = $('#divReportedDate').datepicker('getDate');
    return $('#divReportedDate').datepicker('getDate');
 }
public InitilaizeComponent() {
// for (let i = 0; i < this.organizationInfo.OperationHours.length ; i++) {

//      $('#opentimepicker'+ i).timepicker({});
//      $('#closetimepicker'+ i).timepicker({});
//   }
//this.getTime();
  this.organizationInfo.FoundedOn = $('#divReportedDate').datepicker('getDate');
}

public SetDateFields() {
  this.organizationInfo.FoundedOn = $('#divReportedDate').datepicker('getDate');
  for (let i = 0; i < this.organizationInfo.OperationHours.length ; i++) {

  //if (this.organizationInfo.OperationHours[i].IsSelected) {
 // this.organizationInfo.OperationHours[i].StartTime =  $('#opentimepicker'+ i).val();
  //this.organizationInfo.OperationHours[i].EndTime =  $('#closetimepicker'+ i).val();
  //}
  }
}
public onEmailValidate(emailaddress:string, invalid: boolean)
    {
       var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 

      //Update the model after validation to check if the save button has to be disabled or not.
      return (emailaddress == '' || invalid  || !re.test(emailaddress))?true:false;
    }
public onPersonEmailValidate(emailaddress:string, invalid: boolean)
    {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 
      //Update the model after validation to check if the save button has to be disabled or not.
      return (emailaddress == '' || invalid  || !re.test(emailaddress))?true:false;
    }
  public isOperationHourSelected() {
   if( this.organizationInfo.OperationHours.filter(x=>x.IsSelected).length > 0  ) {
     return true;
   } else {
     return false;
   }
  }  
}
